import React from "react";
import { Route, Switch } from "react-router-dom";
import ProductHuntAdmin from "../ProductHunt-admin/ProductHuntAdmin";
import DashboardAdmin from "../Dashboard-admin/DashboardAdmin";
import ClientsAdmin from "../Clients-admin/ClientsAdmin";

const AdminRoutes = () => {
  return (
    <>
      <Switch>
        <Route exact path="/dashboard">
          <DashboardAdmin />
        </Route>
        <Route path="/clients">
          <ClientsAdmin />
        </Route>
        <Route path="/producthunt">
          <ProductHuntAdmin />
        </Route>
      </Switch>
    </>
  );
};

export default AdminRoutes;
